if (!customElements.get('training-centre-locations')) {
  customElements.define(
    'training-centre-locations',
    class TrainingCentreLocations extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.addEventListener('click', this.onTabClick.bind(this));
      }

      onTabClick(event) {
        const tab = event.target.closest('.tcl__tab');
        if (!tab) return;

        const cardId = tab.getAttribute('data-tcl-card');
        const targetTabType = tab.getAttribute('data-tcl-tab');
        if (!cardId || !targetTabType) return;

        const card = this.querySelector(`#tcl-card-${cardId}`);
        if (!card) return;

        // Toggle active state for tab buttons
        const cardTabs = card.querySelectorAll('.tcl__tab');
        cardTabs.forEach((t) => {
          const isMatch = t.getAttribute('data-tcl-tab') === targetTabType;
          t.classList.toggle('tcl__tab--active', isMatch);
          t.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });

        // Toggle active state for image panels
        const cardPanels = card.querySelectorAll('.tcl__image-panel');
        cardPanels.forEach((panel) => {
          const isMatch = panel.getAttribute('data-tcl-panel') === targetTabType;
          panel.classList.toggle('tcl__image-panel--active', isMatch);
        });
      }
    }
  );
}
